import React, { useRef } from 'react';
import { Box } from '@common-fe/common-fe';

import AutoInvestment from '../AutoInvestment';
import useIsFullLiquidation from '../hooks/useIsFullLiquidation';
import useIsModelSwitching from '../hooks/useIsModelSwitching';

import InvestmentDonut from './InvestmentsBanner/InvestmentDonut';
import SliderPL from './InvestmentsBanner/SliderPL';
import { useGetInvestorAccountId } from './hook';
import InvestmentsActivitiesPreview from './InvestmentsActivitiesPreview';
import InvestmentsBanner from './InvestmentsBanner';
import InvestmentsFooter from './InvestmentsFooter';
import InvestmentsSwitchBanner from './InvestmentsSwitchBanner';

interface Props {}
const InvestmentsDashboard: React.FC<Props> = () => {
  const ref = useRef<HTMLDivElement>(null);
  const accountId = useGetInvestorAccountId();
  const { isFullLiquidated, isFullLiquidation } = useIsFullLiquidation({ accountId });
  const isModelSwitching = useIsModelSwitching(accountId);

  if (isModelSwitching || isFullLiquidated) {
    return (
      <Box>
        <InvestmentsSwitchBanner />
        <InvestmentsFooter />
      </Box>
    );
  }
  return (
    <Box direction="column">
      <Box ref={ref}>
        <InvestmentsBanner>
          <SliderPL parentRef={ref} />
          <InvestmentDonut />
        </InvestmentsBanner>
      </Box>
      {isFullLiquidation && (
        <Box margin={{ top: 'spacing24' }}>
          <InvestmentsSwitchBanner />
        </Box>
      )}

      <AutoInvestment accountId={accountId} isRedesignMode />

      <InvestmentsActivitiesPreview />
      <InvestmentsFooter />
    </Box>
  );
};
export default InvestmentsDashboard;
